function getCookie(name) {
    const matches = document.cookie.match(new RegExp(
        `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function openPopup(el) {
    document.cookie = 'anniversary=true'
    document.body.classList.add('preview-page')
    el.classList.add("opened");
}

function closePopup(el) {
    document.body.classList.remove('preview-page')
    el.classList.remove("opened");
}

export function initAnniversary() {
    const popup = document.querySelector('#popup-anniversary');
    const popupBtn = document.querySelector('.anniversary__btn');
    const popupClose = document.querySelector('.anniversary__close');

    if (!popup || !popupClose)
        return;

    const cookie = getCookie('anniversary')

    if (cookie)
        return;

    popupClose.addEventListener('click', () => {
        closePopup(popup);
    })
    popupBtn.addEventListener('click', () => {
        closePopup(popup);
    })

    setTimeout(() => {
        openPopup(popup);
    }, 500)
}


// WEBPACK FOOTER //
// ./src/js/new-design/initAnniversary.js